var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_17743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.999 8.00001C15.999 9.05065 15.7921 10.091 15.39 11.0617C14.988 12.0323 14.3987 12.9143 13.6558 13.6572C12.9128 14.4001 12.0309 14.9894 11.0602 15.3915C10.0895 15.7936 9.04919 16.0005 7.99855 16.0005C6.94791 16.0005 5.90755 15.7936 4.93689 15.3915C3.96622 14.9894 3.08425 14.4001 2.34134 13.6572C1.59842 12.9143 1.00911 12.0323 0.607049 11.0617C0.204986 10.091 -0.00195314 9.05065 -0.00195312 8.00001C-0.00195309 5.87815 0.840954 3.84319 2.34134 2.3428C3.84172 0.842419 5.87668 -0.000488281 7.99855 -0.000488281C10.1204 -0.000488281 12.1554 0.842419 13.6558 2.3428C15.1561 3.84319 15.999 5.87815 15.999 8.00001Z",
    fill: "url(#paint0_linear_10487_17743)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10487_17743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 13.551C5.19922 14.079 6.45222 13.995 7.99922 13.995C9.54522 13.995 10.7992 14.079 10.7992 13.551C10.7992 12.915 9.54522 12.5 7.99922 12.5C6.45222 12.5 5.19922 12.915 5.19922 13.551Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 13.551C5.19922 14.079 6.45222 13.995 7.99922 13.995C9.54522 13.995 10.7992 14.079 10.7992 13.551C10.7992 12.915 9.54522 12.5 7.99922 12.5C6.45222 12.5 5.19922 12.915 5.19922 13.551Z",
    fill: "url(#paint1_linear_10487_17743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59968 9.83088C3.59968 9.04088 4.13769 8.40088 4.79969 8.40088C5.46269 8.40088 5.99969 9.04088 5.99969 9.83088C5.99969 10.1609 5.90669 10.4639 5.74769 10.7049C5.67339 10.8159 5.55973 10.8945 5.42968 10.9249C5.27968 10.9609 5.05669 10.9999 4.79969 10.9999C4.54269 10.9999 4.31869 10.9609 4.16969 10.9249C4.03951 10.8948 3.92576 10.8161 3.85168 10.7049C3.68426 10.4444 3.59667 10.1406 3.59968 9.83088ZM9.99968 9.83088C9.99968 9.04088 10.5367 8.40088 11.1997 8.40088C11.8617 8.40088 12.3997 9.04088 12.3997 9.83088C12.3997 10.1609 12.3057 10.4639 12.1477 10.7049C12.0736 10.8161 11.9599 10.8948 11.8297 10.9249C11.6227 10.9749 11.4117 10.9999 11.1997 10.9999C10.9427 10.9999 10.7197 10.9609 10.5697 10.9249C10.439 10.8947 10.3247 10.8161 10.2497 10.7049C10.0834 10.4439 9.99653 10.1403 9.99968 9.83088Z",
    fill: "url(#paint2_linear_10487_17743)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10487_17743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59968 9.83088C3.59968 9.04088 4.13769 8.40088 4.79969 8.40088C5.46269 8.40088 5.99969 9.04088 5.99969 9.83088C5.99969 10.1609 5.90669 10.4639 5.74769 10.7049C5.67339 10.8159 5.55973 10.8945 5.42968 10.9249C5.27968 10.9609 5.05669 10.9999 4.79969 10.9999C4.54269 10.9999 4.31869 10.9609 4.16969 10.9249C4.03951 10.8948 3.92576 10.8161 3.85168 10.7049C3.68426 10.4444 3.59667 10.1406 3.59968 9.83088ZM9.99968 9.83088C9.99968 9.04088 10.5367 8.40088 11.1997 8.40088C11.8617 8.40088 12.3997 9.04088 12.3997 9.83088C12.3997 10.1609 12.3057 10.4639 12.1477 10.7049C12.0736 10.8161 11.9599 10.8948 11.8297 10.9249C11.6227 10.9749 11.4117 10.9999 11.1997 10.9999C10.9427 10.9999 10.7197 10.9609 10.5697 10.9249C10.439 10.8947 10.3247 10.8161 10.2497 10.7049C10.0834 10.4439 9.99653 10.1403 9.99968 9.83088Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.9675 9.33311C4.97232 9.35612 4.97467 9.37959 4.9745 9.40311C4.9745 9.60511 4.7985 9.77011 4.5805 9.77011C4.3635 9.77011 4.1875 9.60511 4.1875 9.40411C4.1875 9.32111 4.2175 9.24411 4.2675 9.18311C4.4915 9.23611 4.7275 9.28711 4.9675 9.33311ZM10.8945 9.77011C10.6835 9.77011 10.5115 9.61711 10.5015 9.42211C10.7595 9.38411 11.0165 9.33711 11.2665 9.28611C11.2805 9.32411 11.2875 9.36411 11.2865 9.40511C11.2865 9.60511 11.1115 9.77011 10.8935 9.77011H10.8945Z",
    fill: "#4F4F67"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_10487_17743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99959 7.6C8.99959 7.154 9.16259 7 9.44459 7C9.72459 7 9.85859 7.276 9.95059 8.066C11.0786 8.066 12.9886 7.532 13.1726 7.532C13.3506 7.532 13.4496 7.617 13.4896 7.799C13.5246 7.957 13.4666 8.107 13.2686 8.199C12.6476 8.486 10.8256 9.134 9.28459 9.134C9.11659 9.134 8.99959 9.048 8.99959 8.833V7.6ZM6.04859 8.066C6.13959 7.276 6.27459 7 6.55459 7C6.83659 7 6.99959 7.154 6.99959 7.6V8.833C6.99959 9.048 6.88259 9.134 6.71459 9.134C5.17359 9.134 3.35159 8.486 2.73059 8.199C2.53259 8.107 2.47459 7.957 2.50959 7.799C2.54959 7.617 2.64959 7.532 2.82659 7.532C3.01059 7.532 4.92059 8.066 6.04859 8.066Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.99959 7.6C8.99959 7.154 9.16259 7 9.44459 7C9.72459 7 9.85859 7.276 9.95059 8.066C11.0786 8.066 12.9886 7.532 13.1726 7.532C13.3506 7.532 13.4496 7.617 13.4896 7.799C13.5246 7.957 13.4666 8.107 13.2686 8.199C12.6476 8.486 10.8256 9.134 9.28459 9.134C9.11659 9.134 8.99959 9.048 8.99959 8.833V7.6ZM6.04859 8.066C6.13959 7.276 6.27459 7 6.55459 7C6.83659 7 6.99959 7.154 6.99959 7.6V8.833C6.99959 9.048 6.88259 9.134 6.71459 9.134C5.17359 9.134 3.35159 8.486 2.73059 8.199C2.53259 8.107 2.47459 7.957 2.50959 7.799C2.54959 7.617 2.64959 7.532 2.82659 7.532C3.01059 7.532 4.92059 8.066 6.04859 8.066Z",
    fill: "url(#paint3_linear_10487_17743)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10487_17743",
    x: 4.19922,
    y: 12.5,
    width: 7.59961,
    height: 3.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.509681 0 0 0 0 0 0 0 0 0.371207 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10487_17743"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10487_17743",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10487_17743",
    x: 2.59961,
    y: 7.40088,
    width: 10.8008,
    height: 4.59912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0387428 0 0 0 0 0.0406183 0 0 0 0 0.0875053 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10487_17743"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10487_17743",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_10487_17743",
    x: 2.4,
    y: 7,
    width: 11.2,
    height: 2.83379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.565875 0 0 0 0 0.151272 0 0 0 0 0 0 0 0 0.15024 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10487_17743"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10487_17743",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10487_17743",
    x1: 7.99905,
    y1: 0.0000115995,
    x2: 7.99905,
    y2: 10.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10487_17743",
    x1: 7.99922,
    y1: 12.703,
    x2: 7.99922,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661C04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10487_17743",
    x1: 7.99968,
    y1: 8.39988,
    x2: 7.99968,
    y2: 10.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#3B426A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10487_17743",
    x1: 11.6146,
    y1: 9.333,
    x2: 11.6146,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A2F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D44800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_17743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.e3a11d6639572fd1f5900a0969aaae2b.svg";
export { ForwardRef as ReactComponent };